import {Component, ContentChild, Input, TemplateRef} from "@angular/core";

@Component({
    selector: "fui-deprecated-autocomplete-control-result",
    styleUrls: ["deprecated-autocomplete-control-result.component.scss"],
    templateUrl: "./deprecated-autocomplete-control-result.component.html"
})
export class FUIDeprecatedAutocompleteControlResultComponent {
    @ContentChild("autocompletecontrolresult", {read: TemplateRef}) public autocompleteControlResult: TemplateRef<HTMLTemplateElement>;
    @Input() public result: any;
}
